import IPartnerWalletOrderBase from "@/module/main/dto/financing-v3/IPartnerWalletOrderBase";
import IAmount from "@/module/main/dto/IAmount";
import IOrderItem from "@/module/main/dto/financing-v3/IOrderItem";

export default class PartnerWalletOrderBase implements IPartnerWalletOrderBase
{
    public readonly amount: IAmount;
    public readonly items: IOrderItem[];
    public readonly number?: string;

    constructor(props: IPartnerWalletOrderBase)
    {
        this.amount = props.amount;
        this.items = props.items;
        this.number = props.number;
    }
}
